import enLocale from 'date-fns/locale/en-US';

import { availableLanguages } from '../../../utils/translation/i18n';

export const datePickerLocaleMap: {
  [key in keyof typeof availableLanguages]: Locale;
} = {
  en: enLocale,
};
